import styles from './Bar.module.scss'

type Props = {
  winNumber: string
  count: number
  max: number
  mostRecentWinNumber: number
}

const Bar: React.FC<Props> = ({winNumber, count, max, mostRecentWinNumber}: Props) => {
  const backgroundColor = '#86a579'
  const active = `${mostRecentWinNumber}` === winNumber
  if (!max) max = 1
  return (
    <div className={styles.barOuter}>
      {winNumber}
      <div className={styles.secondaryContainer}>
        <div className={styles.growingBar} style={active ? {backgroundColor, flexGrow: count/max} : {flexGrow: count/max}}>
          {count}
        </div>
        <div style={{flexGrow: 1 - count/max}}/>
      </div>

    </div>
  )
}

export default Bar